module.exports = __webpack_public_path__ + "assets/37ceb2583d1aa9cb431914b70bef61fe.png";